export function optionalLanguageCode(value, normalize) {
  const raw = String(value || "").trim();
  return raw ? normalize(raw) : "";
}

export function selectLocaleState({ languageCode, nextLanguageCode, authenticated, bypass }) {
  const selected = String(nextLanguageCode || "").trim() || languageCode;
  const shouldPersist = Boolean(authenticated && !bypass);
  return {
    languageCode: selected,
    pendingProfileLanguage: authenticated ? selected : "",
    persistenceStatus: shouldPersist ? "pending" : "idle",
    persistenceError: "",
  };
}

export function reconcileProfileLocale({
  languageCode,
  profileLanguageCode,
  pendingProfileLanguage,
  persistenceStatus,
}) {
  const pending = String(pendingProfileLanguage || "").trim();
  const profile = String(profileLanguageCode || "").trim();

  if (!pending) {
    return {
      languageCode: profile || languageCode,
      pendingProfileLanguage: "",
      profileConfirmed: false,
      preserveSelection: false,
    };
  }

  // A matching profile observed while the write is still in flight may simply
  // be the prior value (for example, English → French → English). Wait until
  // the serialised write succeeds before retiring the transient guard.
  if (profile === pending && persistenceStatus !== "pending") {
    return {
      languageCode,
      pendingProfileLanguage: "",
      profileConfirmed: true,
      preserveSelection: false,
    };
  }

  return {
    languageCode: pending,
    pendingProfileLanguage: pending,
    profileConfirmed: false,
    preserveSelection: true,
  };
}

export function failLocalePersistence({ languageCode, pendingProfileLanguage, error }) {
  return {
    languageCode,
    pendingProfileLanguage,
    persistenceStatus: "failed",
    persistenceError: String(error || "Language preference could not be saved."),
  };
}
